import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'rootcause-title';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Root Cause',
};

const rootcauseTitle = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { rootcauseTitle };
